import React from 'react';

export default function SkeletonCard({ width = '100%', height = '120px', rounded = 'rounded-xl', className = '' }) {
  return (
    <div
      className={`skeleton-shimmer ${rounded} ${className}`}
      style={{ width, height, minHeight: height }}
      aria-hidden="true"
    />
  );
}
